export default __webpack_public_path__ + "static/media/PhoneMockup.f704aba1.png";